export { PerspectiveCameraExpand } from './PerspectiveCamera'
export type { vector3Array, FocusReturn, FollowParamsOption, CameraExpandInterface } from './PerspectiveCamera'
